var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderAscendingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 5,
    viewBox: "0 0 12 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38102 5C0.913376 5 0.701675 4.41527 1.06093 4.11589L5.67991 0.266745C5.86533 0.112225 6.13467 0.112225 6.32009 0.266745L10.9391 4.11589C11.2983 4.41527 11.0866 5 10.619 5L6 5L1.38102 5Z",
    fill: "#899AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderAscendingInactive);
export default __webpack_public_path__ + "static/media/order_ascending_inactive.cafbc4160acc638df984d8e5f0afe984.svg";
export { ForwardRef as ReactComponent };